import React, {useContext} from 'react';
import Markup from '../../markup';
import BuilderContext from "../../builder/hooks/context";
import {ButtonIconClose, IconAsset} from "../../markup/Screens/ModalCpMembers";

function ModalCompleteMembers (display){
    const { builder } = useContext(BuilderContext);
    return(
        <>
            <Markup.Screen.ModalCpMembers.WrapModal show={display}>
                <Markup.Screen.ModalCpMembers.Overlay/>
                <Markup.Screen.ModalCpMembers.Modal themeColor={builder.membersData.colorTheme}>
                    <Markup.Screen.ModalCpMembers.ButtonIconClose onClick={() => builder.updateShowCompMessage(false)}/>
                    <Markup.Screen.ModalCpMembers.FirstRow>
                        <Markup.Screen.ModalCpMembers.IconAsset/>
                        <Markup.Screen.ModalCpMembers.H4 themeColor={builder.membersData.colorTheme}>THERE ARE INCOMPLETE ITEMS IN YOUR BUILD</Markup.Screen.ModalCpMembers.H4>
                    </Markup.Screen.ModalCpMembers.FirstRow>
                    <Markup.Screen.ModalCpMembers.P themeColor={builder.membersData.colorTheme}>To continue, please make sure the items in your build have been added to your cart.
                        To do this, click on the items that are highlighted with an error, adjust the specs of the item
                        to your preferences and click the ADD TO CART button when you are finished with the item.
                    </Markup.Screen.ModalCpMembers.P>
                </Markup.Screen.ModalCpMembers.Modal>
            </Markup.Screen.ModalCpMembers.WrapModal>
        </>
    );
};

export default React.memo(ModalCompleteMembers);